const AddTierButton = ({ label = "Thêm tùy chỉnh", onClick }) => {
  return (
    <button
      type="button"
      onClick={onClick}
      className="flex h-10 items-center justify-center gap-2 rounded-[8px] border border-dashed border-[#D2D5DA] bg-[#F1F6FE] px-4 text-sm font-medium leading-5 text-[#2E60F3] transition-colors hover:border-blue-400 hover:bg-blue-50"
    >
      <span className="font-medium">{label}</span>
      <svg className="h-5 w-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M12 6v6m0 0v6m0-6h6m-6 0H6"
        />
      </svg>
    </button>
  );
};

export default AddTierButton;
